import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import ShortcutManager from "../../components/ShortcutManager";
import "../../styles/globals.css";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <ShortcutManager />
    </div>
  );
};

export default App;
